<template>
  <v-select
      v-model="model"
      :options="getAllActivities"
      v-bind="selectProps"
      label="label"
      :reduce="(activity) => activity.value"
      :placeholder="placeholder"
  />
</template>

<script>
export default {
  name: 'ActivitySelectBox',
  props: {
    value: {
      required: true,
    },
    selectProps:{
      default: () => ({})
    },
    disabled:{
      type: Boolean,
      default: () => false
    },
    clearable:{
      type: Boolean,
      default: () => false
    },
    multiple:{
      type: Boolean,
      default: () => false
    },
    placeholder:{
      type: String,
      default: () => ''
    }
  },
  computed:{
    // Labels resolved through i18n (userActivity.actions.*) so the list follows the app language
    getAllActivities() {
      const t = (key, fallback) => (this.$te(`userActivity.actions.${key}`) ? this.$t(`userActivity.actions.${key}`) : fallback);
      return [
        { label: t('LOGIN', 'Login'), value: 'Login' },
        { label: t('LOGIN_FAILED', 'Login failed'), value: 'Login-Failed' },
        { label: t('RENEW_PASSWORD', 'Renew password'), value: 'Renew Password' },
        { label: t('CREATE', 'Create'), value: 'CREATE' },
        { label: t('UPDATE', 'Update'), value: 'UPDATE' },
        { label: t('UPDATE_PART', 'Update partly'), value: 'UPDATE_PART' },
        { label: t('DELETE', 'Delete'), value: 'DELETE' },
        { label: t('DUPLICATE', 'Duplicate'), value: 'DUPLICATE' },
        { label: t('RETRIEVE', 'Retrieve'), value: 'RETRIEVE' },
        { label: t('GET_ALL', 'Get all'), value: 'Get All' },
        { label: t('HIERARCHY', 'Hierarchy'), value: 'Hierarchy' },
        { label: t('MONETARY_TRANSACTION', 'Monetary transaction'), value: 'MONETARY_TRANSACTION' },
        { label: t('APPROVE', 'KYC approve'), value: 'APPROVE' },
        { label: t('DECLINE', 'KYC decline'), value: 'DECLINE' },
        { label: t('STATUS_CHANGE', 'Ticket status change'), value: 'STATUS_CHANGE' },
        { label: t('COMMENT', 'Ticket comment'), value: 'COMMENT' },
        { label: t('AFFILIATE_REGISTRATION', 'Affiliate registration'), value: 'AFFILIATE_REGISTRATION' },
        { label: t('CALL', 'Call'), value: 'CALL' },
        { label: t('CALL_FAILED', 'Call failed'), value: 'CALL_FAILED' },
      ];
    },
    model:{
      get(){
        return this.value;
      },
      set(value){
        this.$emit('input',value);
      }
    },
    _selectProps(){
      let props = {...this.$props, ...this.selectProps}
      delete props.value
      delete props.options
      delete props.label
      delete props.reduce
      return props
    }
  }
}
</script>

<style scoped>

</style>
